import React from 'react';
import { Avatar } from 'antd';
import { UserOutlined } from '@ant-design/icons';

import avatar1 from '../assets/avatars/1.png';
import avatar2 from '../assets/avatars/2.png';
import avatar3 from '../assets/avatars/3.png';
import avatar4 from '../assets/avatars/4.png';
import avatar5 from '../assets/avatars/5.png';
import avatar6 from '../assets/avatars/6.png';
import avatar7 from '../assets/avatars/7.png';
import avatar8 from '../assets/avatars/8.png';
import avatar9 from '../assets/avatars/9.png';
import avatar10 from '../assets/avatars/10.png';
import avatar11 from '../assets/avatars/11.png';
import avatar12 from '../assets/avatars/12.png';

const AVATARS = {
    1: avatar1,
    2: avatar2,
    3: avatar3,
    4: avatar4,
    5: avatar5,
    6: avatar6,
    7: avatar7,
    8: avatar8,
    9: avatar9,
    10: avatar10,
    11: avatar11,
    12: avatar12
};

const AvatarDisplay = ({
                           avatarId,
                           size = 64,
                           className = '',
                           style = {},
                           showBorder = true,
                           onClick = null
                       }) => {
    const avatarSrc = AVATARS[avatarId];

    return (
        <Avatar
            size={size}
            src={avatarSrc}
            icon={!avatarSrc ? <UserOutlined /> : null}
            className={`player-avatar ${className} ${showBorder ? 'with-border' : ''}`}
            style={{
                border: showBorder ? '3px solid var(--color-light-green)' : 'none',
                boxShadow: showBorder ? '0 4px 12px rgba(0, 0, 0, 0.3)' : 'none',
                cursor: onClick ? 'pointer' : 'default',
                ...style
            }}
            onClick={onClick}
        />
    );
};

export default AvatarDisplay;